import * as Authservices from "../../Services/services";

// User Segments (CI-958). The segments screen and the series audience picker own
// their own state, so these stay out of the store — same as the curated-collection search.
const request = (call) => (data) => () => new Promise((resolve, reject) => {
    call(data)
        .then((res) => {
            if (res?.status >= 200 && res?.status < 300) resolve(res.data);
        })
        .catch((err) => reject(err?.response?.data));
});

export const getUserSegments = request(Authservices.getUserSegments);
export const getUserSegmentDetails = request(Authservices.getUserSegmentDetails);
export const addUserSegment = request(Authservices.addUserSegment);
export const updateUserSegment = request(Authservices.updateUserSegment);
export const deleteUserSegment = request(Authservices.deleteUserSegment);
